/**
 * Treat trailing slashes like missing (e.g. /en/ → /en) so direct visits to
 * https://uido.pl/en/ still match home routes (loader, bootstrap lock, etc.).
 */
export const normalizeHomePathname = (pathname) => {
  if (pathname == null || pathname === "") return "/";
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

export const isHomePath = (pathname) => {
  if (pathname == null) return false;
  const p = normalizeHomePathname(pathname);
  return (
    p === "/" ||
    p === "/en" ||
    p === "/home" ||
    p === "/en/home"
  );
};
